import { Link } from "react-router-dom";
import { SITE, whatsappLink } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-10 lg:mb-14">
            <div className="lg:w-[40%]">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-taxi-fill text-sm" />
                </div>
                <span className="font-heading text-xl font-semibold tracking-tight">
                  GOOD RIDES
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed mb-5 max-w-xs">
                Premium private driver and LAX airport transfer service in Los
                Angeles, California. Comfort, trust, and local expertise for an
                unforgettable ride.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href={SITE.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-base" />
                </a>
                <a
                  href={SITE.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-base" />
                </a>
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-base" />
                </a>
                <a
                  href={`mailto:${SITE.email}`}
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors"
                  aria-label="Email"
                >
                  <i className="ri-mail-line text-base" />
                </a>
              </div>
            </div>

            <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-6 lg:gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-3">
                  Services
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/services" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      LAX Airport Transfer
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Hotel Transfer
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Events &amp; Occasions
                    </Link>
                  </li>
                  <li>
                    <Link to="/tours" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Private City Tours
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-3">
                  Explore
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/tours" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Hollywood &amp; Beverly Hills
                    </Link>
                  </li>
                  <li>
                    <Link to="/tours" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Santa Monica &amp; Venice
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-3">
                  Contact
                </h4>
                <ul className="space-y-2">
                  <li>
                    <a href={`tel:${SITE.phone}`} className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      {SITE.phoneDisplay}
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${SITE.email}`} className="text-background-400 text-sm hover:text-background-50 transition-colors">
                      {SITE.email}
                    </a>
                  </li>
                  <li>
                    <span className="text-background-400 text-sm">
                      Los Angeles, CA
                    </span>
                  </li>
                  <li>
                    <span className="text-background-400 text-sm">
                      24/7 Service
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-background-600 text-xs">
              {new Date().getFullYear()} GOOD RIDES. All rights reserved.
            </p>
            <p className="text-background-600 text-xs">
              {SITE.driver}, Private Driver in Los Angeles
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
